module.exports = __webpack_public_path__ + "archivist_viaggio-nel-tempo.gif?e32d962f11984ccbc0012111bad77fd1";


//////////////////
// WEBPACK FOOTER
// ./src/img/animazioni/archivist_viaggio-nel-tempo.gif
// module id = 374
// module chunks = 0